import React, { useState, useEffect } from "react";
import ProviderCbxFilter from "../utilities/ProviderCbxFilter";

const TracksByBookTable = ({
  gameProviders,
  setSelectedProvider,
  selectedProvider,
  trackList,
  tracksByBooks,
  tracksByBookChangeHandler,
  setTracksByBooks,
  setHasChanges,
  selectAll,
  setSelectAll,
  getTracksListCbx,
  selectedRow,
}) => {
  let headers,
    tableTracksByBook = [];

  headers = (
    <tr className="text-center" style={{ cursor: "default" }}>
      <th hidden>TrackID</th>
      <th style={{ width: "160px" }}>Provider</th>
      <th style={{ width: "130px" }}>Track Code</th>
      <th>Track Name</th>
    </tr>
  );

  // This useEffect filters the table by Provider
  useEffect(() => {
    getTracksListCbx(selectedProvider);
  }, [selectedProvider]);

  if (trackList) {
    trackList.length !== 0
      ? (tableTracksByBook = trackList.map((item, i) => {
          if (tracksByBooks) {
            var className = tracksByBooks.some(
              (books) => books.TrackID === item.TrackID,
            )
              ? "classActiveMultiselect"
              : "";
          }

          return (
            <tr
              key={i}
              className={`${className} ${
                selectedRow === null ? "row-disabled" : ""
              }`}
              onClick={() => tracksByBookChangeHandler(item.TrackID, i)}
              style={{ cursor: "pointer" }}
            >
              <td className="d-none">{item.TrackID}</td>
              {/* Provider Name */}
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "160px",
                  whiteSpace: "normal",
                }}
              >
                {item.ProviderName}
              </td>
              {/* Track Code */}
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "130px",
                }}
              >
                {item.TrackCode}
              </td>
              {/* Track Name */}
              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                {item.TrackName}
              </td>
            </tr>
          );
        }))
      : (tableTracksByBook = (
          <tr>
            <td colSpan={4} style={{ textAlign: "center" }}>
              No Tracks to display
            </td>
          </tr>
        ));
  }

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    if (!selectAll) {
      // If selectAll is false, add trackID that does not exist to tracksByBooks
      const newTracks = trackList.filter((item) =>
        tracksByBooks.every((track) => track.TrackID !== item.TrackID),
      );
      setTracksByBooks((prevTracksByBooks) => [
        ...prevTracksByBooks,
        ...newTracks,
      ]);
    } else {
      // If selectAll is true, remove all trackIDs from tracksByBooks
      setTracksByBooks([]);
    }
    setHasChanges(true);
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Specify which tracks should be available for wagering for each Book.
        </p>
      </div>
      <div>
        {gameProviders && (
          <div style={{ textAlign: "center" }}>
            <ProviderCbxFilter
              gameProviders={gameProviders}
              setSelectedProvider={setSelectedProvider}
              selectedProvider={selectedProvider}
              widthCbx={"50%"}
              label={true}
              disabled={selectedRow === null}
            />
          </div>
        )}
      </div>
      <div className="form-check mt-2">
        <input
          type="checkbox"
          className="form-check-input"
          id="exampleCheck1"
          checked={selectAll}
          onChange={handleSelectAll}
          disabled={selectedRow === null}
          style={{ cursor: "pointer" }}
        />
        <label
          className="form-check-label"
          htmlFor="exampleCheck1"
          style={{ color: "#8c8c8c", fontSize: "16px" }}
        >
          Select All
        </label>
      </div>

      {trackList && (
        <div
          className="mt-2 tracksByBookTables"
          style={{
            overflow: "auto",
            marginTop: "10px",
            boxShadow: "-10px 5px 10px #d9e6f2",
          }}
        >
          <table className="table table-hover table-sm">
            <thead
              style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
            >
              {headers}
            </thead>
            <tbody className="table-lg">{tableTracksByBook}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TracksByBookTable;
